import React from 'react';
import { useCookies } from '../context/CookieContext';
import '../assest/CookieBanner.css';

const CookieBanner = () => {
  const { 
    showCookieBanner, 
    acceptAllCookies, 
    rejectAllCookies, 
    openCookieSettings 
  } = useCookies();

  if (!showCookieBanner) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <h3>Çerez Kullanımı</h3>
          <p>
            Bu web sitesi deneyiminizi geliştirmek için çerezler kullanmaktadır. 
            Sitemizi kullanmaya devam ederek çerez kullanımımızı kabul etmiş olursunuz. 
            Daha fazla bilgi için{' '}
            <button 
              className="cookie-settings-link" 
              onClick={openCookieSettings}
            >
              çerez ayarları
            </button>
            nı ziyaret edin.
          </p>
        </div>
        
        <div className="cookie-banner-actions">
          <button 
            className="cookie-btn cookie-btn-secondary" 
            onClick={rejectAllCookies}
          >
            Sadece Gerekli
          </button>
          <button 
            className="cookie-btn cookie-btn-primary" 
            onClick={acceptAllCookies}
          >
            Tümünü Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
